// @flow
import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { User } from '../../types'
import { fetchProperty } from '../../actions/properties'
import { createTour } from '../../actions/forms'
import PageHeader from '../../components/PageHeader'
import PropertyCard from '../../components/PropertyCard'
import GoogleMap from '../../components/GoogleMap'
import TourForm from './components/TourForm'

type Props = {
  user: User,
  property: Object,
  location: Object,
  createTour: Function,
  fetchProperty: Function,
  params: { mlsId: number }
}

class NewOffer extends Component {
  componentDidMount() {
    this.props.fetchProperty(this.props.params.mlsId)
  }

  props: Props

  handleSubmit = (data) => this.props.createTour(this.props.user.id, data)

  render() {
    const { property } = this.props
    const address =
      property.address &&
      `${property.address.full}, ${property.address.city}, ${property.address.state} ${property.address.postalCode}`

    return (
      <div>
        <Helmet title="Schedule Tour" />
        <PageHeader text="Schedule a Tour">
          Please let us know when you would like to tour this property. We will
          be in contact to coordinate a time for an in-person or virtual tour.
        </PageHeader>
        <div style={{ padding: '2rem 0' }}>
          <div className="container">
            <div className="row" style={{ marginBottom: '3rem' }}>
              <div className="col-md-6 col-xs-12">
                <PropertyCard property={property} />
              </div>
              <div className="col-md-6 col-xs-12">
                <GoogleMap
                  address={address}
                  lat={property.geo && property.geo.lat}
                  lng={property.geo && property.geo.lng}
                />
              </div>
            </div>
            <TourForm
              property={property}
              onSubmit={this.handleSubmit}
              initialValues={{ ...this.props.location.query }}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    user: state.session.currentUser,
    property: state.properties.current
  }),
  {
    createTour,
    fetchProperty
  }
)(NewOffer)



// WEBPACK FOOTER //
// ./src/views/NewTour/index.js